import { Injectable } from '@angular/core';
import { takeUntil } from 'rxjs/operators';

import { CompanySelection } from '@com-delta-idp/mnx-capability-profile-selector-ui';
import {
  DashboardResponse,
  loginAndGetDashboardResponse
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { PERM_TYPE } from '../constants/profile-selector-constants';
import { ProfileSelectorFacadeHelperService } from './profile-selector-facade-helper.service';

@Injectable({
  providedIn: 'root'
})
export class ProfileSelectorFacadeService extends ProfileSelectorFacadeHelperService {
  getProfileSelectorContent(
    response: Partial<DashboardResponse> | loginAndGetDashboardResponse
  ): void {
    this.profileSelectorContentService
      .getStaticContentForProfileSelectorScreen()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((aemResponse) => {
        this.profileDetails$.next(
          this.profileSelectorAdapterService.getProfileSelectorContent(
            response,
            aemResponse[0],
            aemResponse[1]
          )
        );
        this.displayTermsUse$.next(
          this.profileSelectorAdapterService.isTermsDisplay()
        );
        if (!this.fromProfileStandAlone$.value) this.getSelectedState();
      });
  }

  enableProfileSelector(standalone: boolean): void {
    if (standalone) {
      this.userSession
        .getUserSession()
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((res) => {
          this.getProfileSelectorContent(res);
          this.adobeDataLayer.setDdcfbDataForStandalonePage(res);
          this.setLoginStatus(res);
        });
    } else {
      if (!this.dashboardData?.smNumber) {
        this.userSession
          .getUserSession()
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe((res) => {
            this.getProfileSelectorContent(res);
            this.setLoginStatus(res);
          });
      }
    }
  }

  postAccountType(
    permType: string,
    companyName: string,
    corporateId: string
  ): void {
    const state = this.profileSelectorUtilService.getBusinessAccountState();
    const personal = PERM_TYPE.P;
    const business = PERM_TYPE.B + ':' + state.businessAccountIndex;
    const accountType = permType === PERM_TYPE.P ? personal : business;

    this.postAccountTypeSelection(
      accountType,
      permType,
      companyName,
      business,
      state,
      corporateId
    ).subscribe(() => {
      if (this.profileSelectorUtilService.checkForSkyBonus(permType)) {
        window.location.href = this.redirectToSKyBonusPath();
      }
    });
  }

  accountSelected(params: CompanySelection): void {
    this.profileSelectorUtilService.setAccountCookie(params);
    this.getSelectedState();
    switch (true) {
      case this.profileSelectorUtilService.checkForBusiness(params.permType):
        /*Set Account to Business*/
        this.postAccountType(
          params.permType,
          params.companyName,
          params.corporateId
        );
        this.profileSelectorUtilService.switchBusinessAccountOverlay(
          params.companyName,
          params.permType,
          this.fromProfileStandAlone$.value
        );
        break;
      case this.profileSelectorUtilService.checkForAdmin(params.permType):
        /*Redirect to Admin*/
        this.postAccountType(
          params.permType,
          params.companyName,
          params.corporateId
        );
        break;
      case this.profileSelectorUtilService.checkForSkyBonus(params.permType):
        /*Redirect to SkyBonus*/
        this.postAccountType(
          params.permType,
          params.companyName,
          params.corporateId
        );
        break;
      default:
        /*Set Account to Personal*/
        this.postAccountType(
          params.permType,
          params.companyName,
          params.corporateId
        );
        this.storeCompanyId$.subscribe((value) => {
          if (value) {
            this.profileSelectorUtilService.switchBusinessAccountOverlay(
              params.companyName,
              params.permType,
              this.fromProfileStandAlone$.value
            );
          }
        });
        break;
    }
  }

  getSelectedState(): void {
    const state = this.profileSelectorUtilService.getBusinessAccountState();
    this.personalSelectedState$.next(!state.isBusiness);
    this.businessSelectedState$.next({
      selectedState: state.isBusiness,
      accountIndex: state.businessAccountIndex
    });
  }
}
